import { render, staticRenderFns } from "./BookingAlertUnpaidFinal.vue?vue&type=template&id=468276b3"
import script from "./BookingAlertUnpaidFinal.vue?vue&type=script&lang=js"
export * from "./BookingAlertUnpaidFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports